import { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import Table from 'antd/lib/table';
import { FormattedTime, FormattedMessage } from 'react-intl';
import Tag from 'antd/lib/tag';

import { LogSeverity } from '../../services/constants';

const severityToColor = {
    [LogSeverity.INFO]: 'blue',
    [LogSeverity.WARNING]: 'orange',
    [LogSeverity.ERROR]: 'red',
};

const columns = [
    {
        title: <FormattedMessage id="imports.logs.timestamp" />,
        dataIndex: 'timestamp',
        render: timestamp => (
            <FormattedTime
                value={timestamp}
                year="numeric"
                month="long"
                day="2-digit"
                second="2-digit"
                minute="2-digit"
                hour="2-digit"
            />
        ),
    },
    {
        title: <FormattedMessage id="imports.logs.severity" />,
        dataIndex: 'severity',
        render: severity => <Tag color={severityToColor[severity]}>{severity}</Tag>,
    },
    {
        title: <FormattedMessage id="imports.logs.message" />,
        dataIndex: 'message',
    },
];

const LogList = ({ logs }) => (
    <Fragment>
        <h3>
            <FormattedMessage id="imports.logs.title" />
        </h3>
        <Table dataSource={logs} columns={columns} pagination={false} rowKey={({ id }) => id} />
    </Fragment>
);

LogList.propTypes = {
    logs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            timestamp: PropTypes.instanceOf(Date).isRequired,
            severity: PropTypes.oneOf(Object.values(LogSeverity)).isRequired,
            message: PropTypes.string.isRequired,
        }),
    ),
};

LogList.defaultProps = {
    logs: [],
};

export default LogList;
